import React, { ReactElement } from 'react'
import styled from 'styled-components'

import { ChargePoint } from '../../common/redux/api/web-api'
import isOnline from '../isOnline'
import { isChargingConnector } from '../findChargingConnector'
import useText from '../../common/hooks/useText'

type ChargepointAssignedProps = {
    chargePoint: ChargePoint
}

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
`

export const ChargepointAssigned = ({ chargePoint }: ChargepointAssignedProps): ReactElement => {
    const text = useText()
    return (
        <Wrapper>
            {chargePoint &&
                chargePoint.connectors?.map((connector) => {
                    if (connector && isChargingConnector(connector)) {
                        if (isOnline(chargePoint) && connector?.loadBalancerCurrent > 0) {
                            return (
                                <div key={connector?.connectorId}>
                                    {connector?.installationPhaseMode === '1P' ? (
                                        <span>
                                            {connector?.loadBalancerPhase} - {connector?.loadBalancerCurrent}{' '}
                                            {text('lblAmpereShort')}
                                        </span>
                                    ) : connector?.installationPhaseMode === '3P' &&
                                      connector?.loadBalancerPhase === null ? (
                                        <span>
                                            3P - {connector?.loadBalancerCurrent} {text('lblAmpereShort')}
                                        </span>
                                    ) : (
                                        <span>
                                            {connector?.loadBalancerPhase} - {connector?.loadBalancerCurrent}{' '}
                                            {text('lblAmpereShort')}
                                        </span>
                                    )}
                                </div>
                            )
                        } else if (isOnline(chargePoint) && !connector?.loadBalancerCurrent) {
                            return (
                                <div className="ml-5" key={connector?.connectorId}>
                                    &nbsp;
                                </div>
                            )
                        } else if (!isOnline(chargePoint)) {
                            return (
                                <div key={connector?.connectorId}>
                                    <div>
                                        {text('lblOffline')}: {connector?.loadBalancerOfflinePhase} -{' '}
                                        {connector?.loadBalancerOfflineCurrent} {text('lblAmpereShort')}
                                    </div>
                                </div>
                            )
                        }
                    } else {
                        if (isOnline(chargePoint) && connector?.loadBalancerCurrent > 0) {
                            return (
                                <div key={connector?.connectorId}>
                                    <span className="fa icon-socket"></span>
                                    <span>
                                        {connector?.loadBalancerPhase} - {connector?.loadBalancerCurrent}{' '}
                                        {text('lblAmpereShort')}
                                    </span>
                                </div>
                            )
                        } else if (isOnline(chargePoint) && connector?.loadBalancerCurrent === 0) {
                            return (
                                <div key={connector?.connectorId}>
                                    <span className="fa icon-socket"></span> ---
                                </div>
                            )
                        } else if (!isOnline(chargePoint)) {
                            return (
                                <div key={connector?.connectorId}>
                                    <span className="fa icon-socket"></span> {text('lblOffline')}
                                </div>
                            )
                        }
                    }
                    return null
                })}
        </Wrapper>
    )
}
